/**
 * A button and modal dialog for changing scratchpad settings.
 */
import {t} from "@lingui/core/macro";
import * as React from "react";

import Button from "@khanacademy/wonder-blocks-button";
import {ModalLauncher} from "@khanacademy/wonder-blocks-modal";
import {PermissionsInfo} from "@khan/shared-core";

import withBackboneModels from "#react-components-package/with-backbone-models.tsx";
import type {Scratchpad} from "#scratchpad-base-package/scratchpads.ts";

import DevControls from "./dev-controls.tsx";
import EditControls from "./edit-controls.tsx";

type Props = {
    // Handle saving a scratchpad
    onSave: (saveSettings: boolean) => unknown;
    // The scratchpad Backbone model which is being rendered
    // @ts-expect-error - TS2749 - 'Scratchpad' refers to a value, but is being used as a type here. Did you mean 'typeof Scratchpad'?
    scratchpad: Scratchpad;
};

class ScratchpadSettingsButton extends React.Component<Props> {
    render(): React.ReactNode {
        const SettingsModal = PermissionsInfo.hasAnyPermissions
            ? DevControls
            : EditControls;
        return (
            <ModalLauncher
                modal={({closeModal}) => {
                    return (
                        <SettingsModal
                            scratchpad={this.props.scratchpad}
                            onCancel={closeModal}
                            onSaveAndClose={() => {
                                closeModal();
                                this.props.onSave(true);
                            }}
                        />
                    );
                }}
            >
                {({openModal}) => (
                    <Button kind="secondary" onClick={openModal}>
                        {t`Settings`}
                    </Button>
                )}
            </ModalLauncher>
        );
    }
}

export default withBackboneModels(({scratchpad}: Props) => [scratchpad])(
    ScratchpadSettingsButton,
) as React.ComponentType<
    JSX.LibraryManagedAttributes<
        typeof ScratchpadSettingsButton,
        React.ComponentProps<typeof ScratchpadSettingsButton>
    >
>;
